namespace Areas.Dialogs.TemplateText {
    "use strict";

    let baseURL: string;

    export class TemplateTextDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("TemplateText", closeHandler, parameters, () => {

                if (parameters.postOrPut === "post") {
                    baseURL = "/Dialog/TemplateText/Post"
                } else {
                    baseURL = "/Dialog/TemplateText/Put"
                }

                const form = $("#CreateTemplateTextForm").dxForm("instance");
                form.option("formData",
                    { DailyReportTemplateId: parameters.templateId, TemplateTitle: parameters.templateTitle, ReportNotesTemplate: parameters.reportNotesTemplate });

            });
        }

        protected ok = (e: any) => {
            const form = $("#CreateTemplateTextForm").dxForm("instance");
            const formData: any = form.option("formData");

            const result: any = form.validate();
            let keyId = formData.DailyReportTemplateId;

            if (result.isValid) {
                if (keyId === 0) {
                    sendRequest(`${baseURL}`, JSON.stringify(formData), "POST", () => {
                        this.close(DialogResult.Ok, null);
                    });

                } else {
                    sendRequest(`${baseURL}/${keyId}`, JSON.stringify(formData), "PUT", () => {
                        this.close(DialogResult.Ok, null);
                    });

                }
            }
        }
    }


}
